import { render } from "./RowspanAndColspan.vue?vue&type=template&id=f5c00e8e"
import script from "./RowspanAndColspan.vue?vue&type=script&lang=ts"
export * from "./RowspanAndColspan.vue?vue&type=script&lang=ts"
script.render = render

export default script